import React, { useState, useCallback } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import axios from "axios";
import { Image, Anchor } from "hesus-ui-kit";
import { useDropzone } from "react-dropzone";
import {
  OuterSection,
  ParagraphText,
  FileInputLabel,
  DocumentRow,
  FileName,
  DeleteSpan,
} from "./DocumentDragDrop.styled";
import deleteIcon from "@icons/ic-delete-red.svg";
import DocumentPreview from "@modules/Document/DocumentPreview/DocumentPreview";

const DocumentDragDrop = (props) => {
  const {
    t,
    isEditMode,
    onDocumentUpload,
    documentList,
    selectedProduct,
    existingDocuments,
    setExistingDocuments,
    title,
    description,
    width,
  } = props;

  const [selectedDocument, setSelectedDocument] = useState(null);

  const onDrop = useCallback((acceptedFiles) => {
    const filesArray = documentList;
    acceptedFiles.map((file, index) => {
      filesArray.push(acceptedFiles[index]);
    });
    onDocumentUpload(filesArray);
    // Do something with the files, e.g., store in state, upload to server
  }, []);

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
  });

  const deleteFile = (index) => {
    const fileListArr = Array.from(documentList);
    // const fileListArr = [...documentList];
    fileListArr.splice(index, 1); // here u remove the file

    // recreate file object
    let updatedDocs = [];
    const dT = new DataTransfer();
    if (fileListArr.length > 0) {
      for (let file of fileListArr) {
        dT.items.add(file);
      }
      updatedDocs = dT.files;
    }
    onDocumentUpload(updatedDocs);
  };

  const getDocumentList = (files) => {
    let docs = [];
    for (let i = 0; i < files.length; i++) {
      docs[i] = (
        <FileName key={i}>
          <DeleteSpan>
            {" "}
            <Image
              className="deleteImage"
              src={deleteIcon}
              alt="delete"
              onClick={() => deleteFile(i)}
              styles={{ width: "auto" }}
            />
          </DeleteSpan>{" "}
          {files[i].name}
        </FileName>
      );
    }
    return docs;
  };

  const deleteExistingFile = (id) => {
    const documents = existingDocuments.filter((item) => item.id !== id);
    setExistingDocuments(documents);
  };

  const openPreview = (document) => setSelectedDocument(document);
  const closePreview = () => setSelectedDocument(null);

  const getExistingDocumentList = (files) => {
    let docs = [];
    for (let i = 0; i < files.length; i++) {
      docs[i] = (
        <FileName key={i}>
          <DeleteSpan>
            {" "}
            <Image
              className="deleteImage"
              src={deleteIcon}
              alt="delete"
              onClick={() => deleteExistingFile(files[i].id)}
              styles={{ width: "auto" }}
            />
          </DeleteSpan>{" "}
          <Anchor
            onClick={() => openPreview(files[i])}
            className="document-dragdrop__document-link"
          >
            {files[i].fileName}{" "}
          </Anchor>
        </FileName>
      );
    }
    return docs;
  };

  return (
    <>
      <div style={{ marginTop: "20px" }}>
        <FileInputLabel>{t(title)}</FileInputLabel>
        <OuterSection width={width}>
          <div
            {...getRootProps({ className: "dropzone" })}
            style={{ width: "100%" }}
          >
            <input {...getInputProps()} />
            <ParagraphText>{t(description)}</ParagraphText>
          </div>
        </OuterSection>
      </div>
      {!!isEditMode && (
        <DocumentRow>
          {existingDocuments?.length > 0 &&
            getExistingDocumentList(existingDocuments)}
          {documentList?.length > 0 ? getDocumentList(documentList) : ""}
        </DocumentRow>
      )}
      {!isEditMode && documentList?.length > 0 && (
        <DocumentRow> {getDocumentList(documentList)} </DocumentRow>
      )}
      {selectedDocument && (
        <DocumentPreview document={selectedDocument} onClose={closePreview} />
      )}
    </>
  );
};

DocumentDragDrop.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  width: PropTypes.string,
};

DocumentDragDrop.defaultProps = {
  title: "DOCUMENTS",
  description: "DOCUMENTS_DRAG_DROP_SELECT",
  width: "65%",
};

export default withTranslation()(DocumentDragDrop);
